/**
 * ReservationShareDialog.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Resultado de "Enviar lembrete" fora da agenda (aba Reservas do Início): o
 * mesmo ReservationShare do drawer, num diálogo. Com número próprio mostra que
 * a mensagem saiu; sem ele, a mensagem com o link para copiar ou abrir no
 * WhatsApp.
 *
 * @module ReservationShareDialog
 */

import React from 'react';
import ConfirmDialog from '../../../../../components/ConfirmDialog/ConfirmDialog';
import ReservationShare from './ReservationShare';
import styles from './ReserveSlotDrawer.module.css';

/**
 * @param {Object}   props
 * @param {boolean}  props.isOpen
 * @param {Object}   props.data - resposta de reservations/resend.php
 * @param {Function} props.onClose
 */
export default function ReservationShareDialog({ isOpen, data, onClose }) {
  return (
    <ConfirmDialog isOpen={isOpen} title="Lembrete do cadastro" variant="info" onCancel={onClose} hideFooter>
      <div className={styles.shareBlock}>
        <ReservationShare data={data} />
        <div className={styles.shareActions}>
          <button type="button" className={styles.btnSecondary} onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </ConfirmDialog>
  );
}
